type Colors = {
  [color: string]: string;
};

export const colors: Colors = {
  // Accent Colors
  amaranth: '#ed585d',

  amber: '#ffbf00',

  babyBlue: '#c8e8fa',

  babyGreen: '#CADED8',

  // Base Colors
  babyPink: '#f2d0cf',

  babyYellow: '#ffe6ab',

  black: '#000000',

  black05: '#f6f6f6',

  black10: '#ededed',

  black20: '#dadada',

  black30: '#c6c6c6',

  black40: '#b2b2b2',

  black50: '#9d9d9c',

  black60: '#878787',

  black70: '#706f6f',

  black80: '#575756',

  // Different Scales of Black (%)
  black90: '#1d1d1b',

  brown: '#955D3F',

  // Base Dark Colors
  burgundy: '#ad0016',

  burgundyDark: '#7E0010',

  darkBlue: '#00396C',

  // Blue Scale (%)
  darkBlue40: '#99afc4',

  defaultBackground: '#f4f4f4',

  // Primary Colors
  foraBlue: '#004c90',

  jadeGreen: '#6AB3A9',

  lightGrey: '#E4E4E4',

  orange: '#FF7236',

  petroleumGreen: '#006474',

  salmon: '#F8BB9F',

  sand: '#F9E6D8',

  // Shadow Colors
  shadowDarkBlue: '#00192F',

  skyBlue: '#94c9e2',

  steelGrey: '#92A2A4',

  // Hover colors
  babyGreenHover: '#E4EEEB',

  petroleumGreenHover: '#005968',

  blueHover: '#DAF0FC',

  transparent: 'transparent',
  white: '#ffffff',
};
